"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateType = void 0;
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = __importStar(require("react"));
var icons_1 = require("../../../icons");
var variables_1 = require("../../../style/variables");
var InputContainer_1 = __importDefault(require("../_base/InputContainer"));
var styles_1 = require("./styles");
var moment_1 = __importDefault(require("moment"));
var DateType;
(function (DateType) {
    DateType["START"] = "start";
    DateType["END"] = "end";
})(DateType = exports.DateType || (exports.DateType = {}));
var inputStyle = react_1.css({
    borderBottom: '1px solid transparent',
    width: 80,
    ':focus-visible': {
        borderBottom: " 1px solid var(" + variables_1.ThemeColor.Primary.DEFAULT + ")",
        transition: 'border-color 0.3s ease',
    },
    ':focus': {
        borderBottom: " 1px solid var(" + variables_1.ThemeColor.Primary.DEFAULT + ")",
        transition: 'border-color 0.3s ease',
    },
});
var CustomRangeInput = react_2.default.forwardRef(function (_a, ref) {
    var _b = _a.icon, Icon = _b === void 0 ? icons_1.Calendar : _b, value = _a.value, size = _a.size, error = _a.error, setDateType = _a.setDateType, pickerType = _a.pickerType, _c = _a.nonEditable, nonEditable = _c === void 0 ? false : _c, props = __rest(_a, ["icon", "value", "size", "error", "setDateType", "pickerType", "nonEditable"]);
    var _d = react_2.useState(''), startDate = _d[0], setStartDate = _d[1];
    var _e = react_2.useState(''), endDate = _e[0], setEndDate = _e[1];
    react_2.useEffect(function () {
        var _a, _b, _c, _d;
        // Week picker only returns one date (start date)
        if (pickerType && pickerType === 'Week') {
            var start = moment_1.default(value);
            var end = start.clone().add(6, 'day');
            setStartDate((_a = value === null || value === void 0 ? void 0 : value.split(' - ')) === null || _a === void 0 ? void 0 : _a[0]);
            setEndDate((_b = end.format('MMM DD, yyyy').split(' - ')) === null || _b === void 0 ? void 0 : _b[0]);
            return;
        }
        if (value && (value === null || value === void 0 ? void 0 : value.indexOf(' - ')) > -1) {
            setStartDate((_c = value === null || value === void 0 ? void 0 : value.split(' - ')) === null || _c === void 0 ? void 0 : _c[0]);
            setEndDate((_d = value === null || value === void 0 ? void 0 : value.split(' - ')) === null || _d === void 0 ? void 0 : _d[1]);
        }
    }, [value]);
    var onChangeHandler = function (type, val) {
        if (type === DateType.START) {
            setDateType === null || setDateType === void 0 ? void 0 : setDateType(DateType.START);
            setStartDate(val);
        }
        else {
            setDateType === null || setDateType === void 0 ? void 0 : setDateType(DateType.END);
            setEndDate(val);
        }
    };
    return (react_1.jsx(InputContainer_1.default, __assign({ element: "label", error: error, css: styles_1.style.customInput(true, size) }, props),
        Icon ? react_1.jsx(Icon, null) : undefined,
        nonEditable ?
            react_1.jsx("span", null, startDate)
            :
                react_1.jsx("input", { css: inputStyle, placeholder: "Start Date", id: "end-date-input", value: startDate, onChange: function (e) {
                        onChangeHandler(DateType.START, e.target.value);
                    }, ref: ref }),
        react_1.jsx("span", null, " - "),
        nonEditable ?
            react_1.jsx("span", null, endDate) :
            react_1.jsx("input", { css: inputStyle, id: "end-date-input", placeholder: "End Date", value: endDate, onChange: function (e) { return onChangeHandler(DateType.END, e.target.value); }, ref: ref })));
});
exports.default = CustomRangeInput;
